
export default function criarCadastroPublicoDTO({
        nome, 
        nascimento, 
        email, 
        login, 
        senha, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade,
        uf
    }){ 
        return{
        nome, 
        nascimento, 
        email, 
        login, 
        senha, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade, 
        uf,

        // Campos internos  
        acesso:2,
        ativo: true
    }
}